import React, { lazy, Suspense } from "react";

const LazyCreate_Admin = lazy(() => import("./Create_Admin"));
const LazyCreate_HR = lazy(() => import("./Create_HR"));
const LazyListAdmin = lazy(() => import("./ListAdmin"));

export const Create_HR = () => (
  <Suspense fallback="loading...">
    <LazyCreate_HR />
  </Suspense>
);
export const Create_Admin = () => (
  <Suspense fallback="loading...">
    <LazyCreate_Admin />
  </Suspense>
);
export const ListAdmin = () => (
  <Suspense fallback="loading...">
    <LazyListAdmin />
  </Suspense>
);
